export default __webpack_public_path__ + "resources/icons/n440-2440.png";